<div class="row">
  <div class="col">
    <h3 class="deviceOptionsHeader">{{ 'lang.globals.device' | translate }} {{device.id}}</h3>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="tablewrap">
      <div class="d-flex flex-row">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <div class="w-100 tc">
            <div *ngIf="success" class="d-flex justify-content-center">
              <sb-icon
                style="font-size: 5rem" icon="successAnimation"
                [animationOptions]="{autoplay: true, loop: false}" class="green"></sb-icon>
            </div>
            <div *ngIf="!success" class="d-flex justify-content-center">
              <sb-icon
                style="font-size: 5rem" icon="errorAnimation"
                [animationOptions]="{autoplay: true, loop: false}" class="red"></sb-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100 tc"><b>{{message}}</b></p>
        </div>
      </div>
      <div *ngIf="configuration" class="d-flex flex-row bt">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <ng-scrollbar style="width: 100%; height: 200px;">
            <pre class="w-100 tl">{{getConfigurationJSON()}}</pre>
          </ng-scrollbar>
        </div>
      </div>
    </div>
  </div>
</div>
